import React, { useEffect, useState } from 'react';
import "./MatchCar.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import axiosInstance from '../../axiosInstance';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useHistory } from "react-router-dom";

const MatchCar = () => {
    const [carouselImages, setCarouselImages] = useState([]);
    const [gridImages, setGridImages] = useState([]);
    const [selectedThumbnail, setSelectedThumbnail] = useState(0);
    const [selectedImages, setSelectedImages] = useState([]);
    const [imageGroups, setImageGroups] = useState([]);
    const [races, setRaces] = useState([]);
    const [selectedRace, setSelectedRace] = useState(null);
    const [isEditing, setIsEditing] = useState(null);
    const [hasGroups, setHasGroups] = useState(false); // Track if groups exist
    const history = useHistory();

    useEffect(() => {
        const token = localStorage.getItem('token');

        if (!token) {
            history.push("/auth/login");
            return;
        }

        const fetchRaces = async () => {
            try {
                const response = await axiosInstance.get('/cars/getAllRaces', {
                    headers: {
                        Authorization: token,
                    },
                });

                if (response.data.success) {
                    setRaces(response.data.data.raceIds);
                } else {
                    handleAuthError(response.data.error);
                }
            } catch (error) {
                handleAuthError(error.response?.data?.error || error.message);
            }
        };

        fetchRaces();
    }, [history]);

    useEffect(() => {
        if (selectedRace) {
            fetchCarouselImages(selectedRace);
        }
    }, [selectedRace]);

    const fetchCarouselImages = async (raceId) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axiosInstance.get(`/cars/getAllUniqueCars/${raceId}`, {
            headers: { Authorization: token },
        });

        if (response.data && response.data.success) {
            const cars = response.data.data?.cars;

            if (Array.isArray(cars)) {
               const images = cars.map((car) => {
    if (car.thumbnail) {
        const imageUrl = `data:image/jpeg;base64,${car.thumbnail}`;
        return { url: imageUrl, folderId: car.folderId, id: car.id, raceId }; // Ensure ID is included
    }
    return null;
}).filter(image => image !== null);

                setCarouselImages(images);

                if (images.length > 0) {
                    fetchGridImages(images[0].raceId, images[0].folderId);
                }
            }
        } else {
            handleAuthError(response.data.error);
        }
    } catch (error) {
        handleAuthError(error.response?.data?.error || error.message);
    }
};

   const fetchGridImages = async (raceId, folderId) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axiosInstance.post(`/cars/getGridImages`, {
            videoId: raceId, // Assuming videoId is the raceId
            folderId: folderId
        }, {
            headers: { Authorization: token },
        });

        if (response.data && response.data.success) {
            const gridImagesData = response.data.data?.cars || [];

            const images = gridImagesData.map((car) => {
                if (car.thumbnail) {
                    const imageUrl = `data:image/jpeg;base64,${car.thumbnail}`; // Construct the base64 URL
                    return { url: imageUrl, id: car.id }; // Include the image URL and ID
                }
                return null;
            }).filter(image => image !== null); // Filter out any null entries

            setGridImages(images); // Set the grid images in the state
        } else {
            handleAuthError(response.data.error);
        }
    } catch (error) {
        handleAuthError(error.response?.data?.error || error.message);
    }
};



const handleAuthError = (error) => {
        console.error('Authentication or API Error:', error);

        if (error.code === 500 && 
            (error.message === "User is not authorized: invalid token" || 
             error.message === "User is not authorized: jwt expired")) {
            localStorage.removeItem('token');
            history.push("/auth/login");
        }
    };

 const handleRaceClick = async (raceId) => {
    setSelectedRace(raceId);
    const token = localStorage.getItem('token');
    
    try {
        const response = await axiosInstance.get(`/cars/getUserMatchedCars/${raceId}`, {
            headers: { Authorization: token },
        });

        //console.log("API Response:", response.data); // Log the entire response

        if (response.data && response.data.success) {
            const existingCars = response.data.data?.cars;
            console.log("Existing Cars:", existingCars); // Log if cars exist or not

            if (existingCars && existingCars.folders && existingCars.folders.length > 0) {
                // Groups exist, populate them
                const groups = existingCars.folders.map(folder => 
                    folder.matchedImages.map(image => ({
                        url: `data:image/jpeg;base64,${image.thumbnail}`, // Convert base64 to image URL
                        id: image.matchedFolderId, // Use matchedFolderId as the image ID
                        folderId: folder.folderId // Ensure folderId is set
                    }))
                );

                console.log("Populating groups:", groups); // Log the populated groups

                setImageGroups(groups); // Populate image groups
                setIsEditing(true); // Set edit mode
                setHasGroups(true); // Groups exist, show the Delete button
            } else {
                // No groups exist, proceed with normal group creation flow
                console.log("No groups found, proceeding with group creation.");
                setImageGroups([]); // Clear existing groups
                setIsEditing(false); // Set to create mode
                 setHasGroups(false); // Hide the Delete button
            }
        } else {
            console.error("Failed to fetch existing groups", response.data.error);
             setHasGroups(false); // Ensure delete button is hidden if an error occurs
        }
    } catch (error) {
        console.error("Error fetching existing groups", error.response?.data?.error || error.message);
        handleAuthError(error.response?.data?.error || error.message);
    }
};




const editImageGroups = () => {
    if (isEditing === null || isEditing === false) {
        return; // Prevent updating if not in edit mode
    }

    //console.log("----- Editing Group -----");

    // Clone the current image groups to keep track of previous state
    const updatedGroups = [...imageGroups];

    // Get the current group before editing
    const oldGroup = imageGroups[isEditing];
    //console.log("Old Group IDs:", oldGroup.map(img => img.id));

    // Create a new set of selected images from the carousel and thumbnails, allowing undefined ids for new groups
    const isNewGroup = oldGroup.length === 0; // Check if it's a new group
    const newGroupSet = new Set([...selectedImages]); // For new groups, don't filter undefined ids
    //console.log("Selected Images IDs:", selectedImages.map(img => img.id));

    // Add the active image from the carousel
    const activeImage = carouselImages[selectedThumbnail];
    if (isNewGroup || (activeImage && activeImage.id && !oldGroup.some(img => img.id === activeImage.id))) {
        newGroupSet.add(activeImage); // For new groups, allow undefined ids
        //console.log("Active image added to group (new group or valid id)");
    } else {
        //console.log("Active image has undefined id or already exists, not adding");
    }

    // Filter out duplicates based on id only for existing groups
    const uniqueGroup = Array.from(newGroupSet).filter((image, index, self) => {
        return isNewGroup || image.id ? self.findIndex(i => i.id === image.id) === index : true; // Keep all images for new group
    });

    //console.log("Updated Group IDs (after removing duplicates):", uniqueGroup.map(img => img.id));

    // Update the group with the unique images
    updatedGroups[isEditing] = uniqueGroup;

    // Update the grid by removing selected images
    let updatedGridImages = [...gridImages];
    updatedGridImages = updatedGridImages.filter(
        (gridImg) => !uniqueGroup.some(groupImg => groupImg.id === gridImg.id) // Only keep grid images not in the group
    );

    //console.log("Remaining Grid Image IDs (after update):", updatedGridImages.map(img => img.id));

    // Update the state with the new groups and updated grid
    setImageGroups(updatedGroups);
    setGridImages(updatedGridImages);

    // Keep the editing state intact to ensure the button remains "Edit Group"
    //console.log("----- Edit Complete -----");
};


const handleEditGroups = async () => {
    const token = localStorage.getItem('token');

    // Prepare the data in the required format for editing
    const folders = imageGroups.map((group) => {
        return {
            folderId: group[0]?.folderId || 0, // Use folderId from the first image in the group
            matchedImages: group.map((img) => ({
                matchedFolderId: img.id, // Use the correct matchedFolderId for each image
                thumbnail: img.url.split(',')[1], // Extract base64 string for each image
            })),
        };
    });

    const data = {
        folders,
        videoId: selectedRace,
    };

    try {
        // Make the API call to update the group
        const response = await axiosInstance.post('/cars/editUserMatchedCars', data, {
            headers: { Authorization: token },
        });

        if (response.data.success) {
            const messageContainer = document.getElementById('messageContainer');
            messageContainer.textContent = 'Groups updated successfully!';
            messageContainer.style.color = 'green'; // Success message

            // IMPORTANT: Keep isEditing set to true, so the button stays as "Edit Group"
            // Do NOT reset isEditing to null here, as you are still in edit mode
        } else {
            console.error('Failed to update groups');
        }
    } catch (error) {
        console.error('Error updating groups:', error);
    }
};



const handleDeleteGroup = async () => {
    const token = localStorage.getItem('token');

    try {
        // Make the API call to delete the group for the selected race
        const response = await axiosInstance.delete(`/cars/deleteUserMatchedCars/${selectedRace}`, {
            headers: { Authorization: token },
        });

        const messageContainer = document.getElementById('messageContainer');

        if (response.data.success) {
            // Display the success message inside the page
            messageContainer.textContent = response.data.status || 'Group deleted successfully!';
            messageContainer.style.color = 'green'; // Set success message color

            // Redirect to the race list
            setTimeout(() => {
                setSelectedRace(null); // Redirect to the race list after showing the message
            }, 1500);
        } else {
            // Display an error message
            messageContainer.textContent = 'Failed to delete group';
            messageContainer.style.color = 'red'; // Set error message color
        }
    } catch (error) {
        const messageContainer = document.getElementById('messageContainer');
        messageContainer.textContent = 'An error occurred while deleting the group';
        messageContainer.style.color = 'red'; // Set error message color
    }
};


const handleCarouselImageSelection = (index) => {
    setSelectedThumbnail(index);
    const selectedCar = carouselImages[index];

    if (isEditing !== null && selectedCar) {
        // Load grid images for this folder in edit mode
        fetchGridImages(selectedCar.raceId, selectedCar.folderId);
    }
};


const toggleImageSelection = (image) => {
    // Check if the image is already selected
    const isSelected = selectedImages.some(selectedImg => selectedImg.id === image.id);

    setSelectedImages((prevSelectedImages) => {
        if (isSelected) {
            // If the image is already selected, remove it from the selection
            return prevSelectedImages.filter((img) => img.id !== image.id);
        } else {
            // If the image is not selected, add it to the selection
            return [...prevSelectedImages, image];
        }
    });

    // Additionally, update the gridImages state to reflect the selection/deselection visually
    setGridImages((prevGridImages) =>
        prevGridImages.map((gridImg) =>
            gridImg.id === image.id
                ? { ...gridImg, isSelected: !isSelected } // Toggle the isSelected flag
                : gridImg
        )
    );
};



const groupSelectedImages = () => {
    if (selectedThumbnail < 0 || selectedThumbnail >= carouselImages.length) {
        console.error("Selected thumbnail index is out of bounds");
        return;
    }

    const activeImage = carouselImages[selectedThumbnail];

    if (!activeImage) {
        console.error("Active image not found");
        return;
    }

    // **Create a new group with the selected images, including the active image from the carousel**
    const newGroupSet = new Set([activeImage, ...selectedImages]);

    // Add the new group to the existing groups
    setImageGroups((prevGroups) => [...prevGroups, Array.from(newGroupSet)]);

    // **Remove the grouped images from the grid**
    setGridImages((prevGridImages) => {
        return prevGridImages.filter(
            (gridImg) => !Array.from(newGroupSet).some((groupImg) => groupImg.id === gridImg.id)
        );
    });

    // **Clear the selection and reset the thumbnail index**
    setSelectedImages([]);
    setSelectedThumbnail(0);
};










const editImageGroup = async (groupIndex) => {
    const token = localStorage.getItem('token');  // Fetch the token from local storage

    const group = imageGroups[groupIndex];  // Get the selected group images
    const activeImage = group[0];  // The first image of the group will be the active image (carousel image)
    const videoId = selectedRace;  // The race id you clicked initially

    // Fetch the grid images for the current folderId and videoId
    try {
        const response = await axiosInstance.post(
            '/cars/getGridImages',
            {
                folderId: activeImage.folderId,  // Use the folderId from the active image (first image in group)
                videoId: videoId,  // The selected race or car match video ID
            },
            {
                headers: { Authorization: token },  // Pass the token in the header for authorization
            }
        );

        if (response.data && response.data.success) {
            const gridImagesFromAPI = response.data.data?.cars || [];  // Fetch grid images

            // **Update Carousel with the Active Image First**
            const newCarouselImages = [activeImage, ...carouselImages.filter((img) => img.id !== activeImage.id)];
            setCarouselImages(newCarouselImages);

            // **Mark Group Images as Selected in the Grid**
            const updatedGridImages = gridImagesFromAPI.map((img) => {
                return {
                    url: `data:image/jpeg;base64,${img.thumbnail}`,
                    id: img.id,
                    isSelected: group.some((groupImg) => groupImg.id === img.id), // Check if image is in the group
                };
            });

            setGridImages(updatedGridImages); // Update the grid images

            // Ensure that the first image in the carousel is selected
            setSelectedThumbnail(0);

        } else {
            console.error("Failed to fetch grid images from API");
        }
    } catch (error) {
        const messageContainer = document.getElementById('messageContainer');
        const errorMessage = error.response?.data?.error?.message || error.message;
        messageContainer.textContent = `Error fetching grid images: ${errorMessage}`;
        messageContainer.style.color = 'red';  // Set the error message color
        console.error("Error fetching grid images:", errorMessage);
    }

    // Set the selected images for the group being edited
    setSelectedImages(group);
    setIsEditing(groupIndex);  // Mark that we're editing this group
};





















const saveImageGroups = async () => {
    const token = localStorage.getItem('token');

    // Prepare the data in the required format
    const folders = imageGroups.map((group) => {
        return {
            folderId: group[0]?.folderId || 0, // Use folderId from the first image in the group
            matchedImages: group.map((img, index) => ({
                matchedFolderId: index === 0 ? group[0]?.folderId : img.id, // Set matchedFolderId for each image
                thumbnail: img.url.split(',')[1], // Extract base64 string for each image
            })),
        };
    });

    const data = {
        folders,
        videoId: selectedRace,
    };

    try {
        const response = await axiosInstance.post('/cars/saveUserMatchedCars', data, {
            headers: { Authorization: token },
        });

        // Log the full response
       // console.log('API Response:', response.data);

        const messageContainer = document.getElementById('messageContainer');

        if (response.data.success) {
            messageContainer.textContent = 'Groups saved successfully!';
            messageContainer.style.color = 'green'; // Set success message color
        } else {
            messageContainer.textContent = 'Failed to save groups.';
            messageContainer.style.color = 'red'; // Set error message color
            handleAuthError(response.data.error);
        }
    } catch (error) {
        const messageContainer = document.getElementById('messageContainer');
        const errorMessage = error.response?.data?.error?.message || error.message;

        // Check if the error code is 409 and show the specific message
        if (error.response?.data?.error?.code === 409) {
            messageContainer.textContent = 'Grouping against given race is already performed. Please edit or remove that.';
        } else {
            messageContainer.textContent = errorMessage;
        }
        
        messageContainer.style.color = 'red'; // Set error message color
        handleAuthError(errorMessage);
    }
};


const renderGridImages = () => {
    return (
        <Row className="mt-3" id="thum_grid">
            {gridImages.map((image, index) => {
                // Check if the image is already selected
                const isSelected = selectedImages.some(selectedImg => selectedImg.id === image.id);

                return (
                    <Col key={index} xl={3} sm={6} className="mb-3 home-page-card">
                        <div
                            className={`video-card ${isSelected ? 'selected' : ''}`}  // Apply 'selected' class if already in group
                            onClick={() => toggleImageSelection(image)}
                            style={{ border: isSelected ? `3px solid #007bff` : 'none' }}  // Highlight selected images
                        >
                            <div className="video-card-image grid-image">
                                <img
                                    className="img-fluid"
                                    src={image.url}  // Ensure proper image URL
                                    alt={`Grid Image ${index + 1}`}
                                />
                            </div>
                        </div>
                    </Col>
                );
            })}
        </Row>
    );
};




const renderImageGroups = () => {
    return imageGroups.map((group, groupIndex) => (
        <div key={groupIndex} className="image-group">
            <h5>{`Group ${groupIndex + 1}`}</h5>
            <Row>
                {group.map((image, imageIndex) => (
                    <Col key={imageIndex} xl={3} sm={6} className="mb-3 home-page-card">
                        <div className="video-card">
                            <div className="video-card-image grid-image">
                                <img
                                    className="img-fluid"
                                    src={image.url}
                                    alt={`Group ${groupIndex + 1} Image ${imageIndex + 1}`}
                                />
                                {/* Display image ID */}
                                {/*image.id && <p className="image-id">ID: {image.id}</p>*/}
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
            <button className="btn btn-secondary mt-2" onClick={() => editImageGroup(groupIndex)}>
                Edit Group {groupIndex + 1}
            </button>
        </div>
    ));
};

const renderRaces = () => {
    const raceImageUrl = "https://i3.ytimg.com/vi/bHWgc5MPnPA/maxresdefault.jpg"; // Static image URL
        return races.map((race, index) => (
            <Col key={race} xl={3} sm={6} className="mb-3 home-page-card">
                <div className="video-card" onClick={() => handleRaceClick(race)}>
                    <div className="video-card-image">
                        <img className="img-fluid" src={raceImageUrl} alt={`Race ${race}`} />
                    </div>
                    <div className="video-card-title">
                        <h6>{`Race ${race}`}</h6>
                    </div>
                </div>
            </Col>
        ));
    };

    const sliderSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        focusOnSelect: true,
        infinite: false
    };

   return (
    <>
        <ContentWrapper>
            <Container fluid className="pb-0">
                {selectedRace === null ? (
                    <Row className="mb-3" id="races-list">
                        {renderRaces()}
                    </Row>
                ) : (
                    <>
                        <Row className="mb-3" id="mb3_sslp">
                            <Col>
                                <div className="main">
                                    <div className="side">
<Slider {...sliderSettings} afterChange={handleCarouselImageSelection}>
    {carouselImages.map((image, index) => (
        <div key={index} className={`thumbnail-image carousel-image ${index === selectedThumbnail ? 'active' : ''}`}>
            <img className="img-fluid" src={image.url} alt={`Thumbnail ${index + 1}`} />
        </div>
    ))}
</Slider>





                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {renderGridImages()}

                   <Row className="mt-3" id="gs_btn">
    <Col>
        <div className="d-flex">
            {/* Button for creating or editing groups */}
            <button 
                className="btn btn-primary" 
                onClick={isEditing !== null && isEditing !== false ? editImageGroups : groupSelectedImages} 
                disabled={selectedImages.length === 0}
            >
                {isEditing !== null && isEditing !== false ? "Update Group" : "Group Selected Images"}
            </button>

            <button 
                className="btn btn-secondary bcr_btn ml-3" 
                onClick={() => setSelectedRace(null)}
            >
                Back to Race List
            </button>
        </div>
    </Col>
</Row>


                        {/* Render image groups */}
                        {renderImageGroups()}

                        {/* Place Save Groups button outside the group rendering loop */}
                         <Row className="mt-3">
                            <Col className="text-right">
                              {/* This button will call handleEditGroups when editing, and saveImageGroups when creating new groups */}
                                <button 
                                    className={`btn ${isEditing !== null && hasGroups ? 'btn-secondary' : 'btn-success'} sv_btn`} 
                                    onClick={isEditing !== null && hasGroups ? handleEditGroups : saveImageGroups} 
                                    disabled={imageGroups.length === 0}
                                >
                                    {/* Show "Save Groups" if it's a new group, otherwise show "Edit Group" */}
                                    {isEditing !== null && hasGroups ? "Edit Group" : "Save Groups"}
                                </button>

                                {/* Show the Delete button only if groups exist for the selected race */}
                                {hasGroups && (
                                    <button 
                                        className="btn btn-danger ml-3"
                                        onClick={handleDeleteGroup} // Call the delete function when clicked
                                    >
                                        Delete Group
                                    </button>
                                )}
                            </Col>
                        </Row>

                         <Row className="mt-3">
                            <Col className="text-center">
                               <div id="messageContainer"></div>
                            </Col>
                        </Row>
                    </>
                )}
            </Container>
        </ContentWrapper>
        <ThinFooter />
    </>
);


};

export default MatchCar;
